(() => {
  const config = window.__brindeConfig;
  if (!config || !config.ativo || !config.variantId) return;

  const VARIANT_ID = String(config.variantId);
  const MIN_VALUE = config.minValue || 25000;
  let processing = false;

  function getCartTotalWithoutBrinde(cart) {
    return cart.items.reduce((sum, item) => {
      if (String(item.variant_id) === VARIANT_ID) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  function findBrindes(cart) {
    return cart.items.filter(item => String(item.variant_id) === VARIANT_ID);
  }

  async function removeAllBrindes(brindes) {
    for (const b of brindes) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: b.key, quantity: 0 })
      });
    }
  }

  function triggerMinimogUpdate() {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const sectionsParam = sectionsToBundle.length > 0
      ? sectionsToBundle.join(',')
      : 'cart-drawer';

    fetch('/cart.js?sections=' + sectionsParam, { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        if (window.MinimogEvents && window.MinimogTheme) {
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart });
        }
      });
  }

  async function syncBrinde() {
    if (processing) return;
    processing = true;

    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      const total = getCartTotalWithoutBrinde(cart);
      const brindes = findBrindes(cart);

      if (total >= MIN_VALUE && brindes.length === 0 && cart.items.length > 0) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(VARIANT_ID), quantity: 1, properties: { _brinde: 'true' } }]
          })
        });
        triggerMinimogUpdate();
      } else if (total < MIN_VALUE && brindes.length > 0) {
        await removeAllBrindes(brindes);
        triggerMinimogUpdate();
      } else if (brindes.length > 1) {
        await removeAllBrindes(brindes.slice(1));
        triggerMinimogUpdate();
      }
    } catch (e) {
      console.error('[brinde]', e);
    } finally {
      processing = false;
    }
  }

  // Hook Minimog cart events
  document.addEventListener('cart:updated', () => {
    setTimeout(syncBrinde, 300);
  });

  const waitForMinimog = setInterval(() => {
    if (window.MinimogEvents && window.MinimogTheme) {
      clearInterval(waitForMinimog);
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
        setTimeout(syncBrinde, 300);
      });
    }
  }, 200);
  setTimeout(() => clearInterval(waitForMinimog), 5000);

  // Initial sync
  setTimeout(syncBrinde, 500);
})();
